<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} sản vật</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} sản vật</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} sản vật</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="4">
              <el-form-item label="Tên" prop="ten">
                <el-input
                  v-model="mData.dataForm.thong_tin.ten"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Địa chỉ" prop="dia_chi">
                <el-input
                  v-model="mData.dataForm.thong_tin.dia_chi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Email" prop="email">
                <el-input
                  v-model="mData.dataForm.thong_tin.email"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Điện thoại" prop="dien_thoai">
                <el-input
                  v-model="mData.dataForm.thong_tin.dien_thoai"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Website" prop="website">
                <el-input
                  v-model="mData.dataForm.thong_tin.website"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Trạng thái" prop="hien_thi">
                <el-select
                  v-model="mData.dataForm.hien_thi"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listHienThi"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Giới thiệu" prop="thong_tin.gioi_thieu">
                <CknoimgComponent
                  v-model="mData.dataForm.thong_tin.gioi_thieu"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                  @blur="handleBlur('thong_tin.gioi_thieu')"
                ></CknoimgComponent>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Mô tả" prop="chi_tiet.mo_ta">
                <CknoimgComponent
                  v-model="mData.dataForm.chi_tiet.mo_ta"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                  @blur="handleBlur('chi_tiet.mo_ta')"
                ></CknoimgComponent>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import DataService from '@/service/DataService';
import MethodService from '../../../service/MethodService';
import SanVatModel from './SanVatModel';
import SanVatApi from '../../../moduleApi/SanVatApi';
import CknoimgComponent from "../../../component/CknoimgComponent";
export default {
  components: {
    CknoimgComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "SanVat",
        dataDefault: {
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
        },
        dataForm: MethodService.copyObject(SanVatModel.dataForm),
        validForm: SanVatModel.validForm,
      },
    };
  },
  created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "create") {
            await SanVatApi.create(data);
            this.fn_resetForm();
          }
          if (type === "update") {
            data.id = this.$router.currentRoute.params.id;
            await SanVatApi.update(data);
           this.fn_go();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        SanVatModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      let nganh_nghe = await SanVatApi.findById(id);
      if (nganh_nghe.result) {
        this.mData.dataForm = nganh_nghe.result;
      }
    },

    fn_go() {
      this.$router.go(-1);
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    }
  }
}
</script>

<style>

</style>